/**
 * @generated SignedSource<<7f0f8a2c4be9bbcc529bba6d88c3a8f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountriesListRow_country$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "CountriesListRow_country";
};
export type CountriesListRow_country$key = {
  readonly " $data"?: CountriesListRow_country$data;
  readonly " $fragmentSpreads": FragmentRefs<"CountriesListRow_country">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CountriesListRow_country",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "Country",
  "abstractKey": null
};

(node as any).hash = "c196e7a66df3f1bf706858076e9ef8bb";

export default node;
